import styled from 'styled-components';
import {Select as SelectAntd} from 'antd';

export const Select = styled(SelectAntd)`
    width: 100%;
    margin: 0.5rem 0;
`;

export const Option = Select.Option;
